/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LabelDropdownJS_labels$ref: FragmentReference;
declare export opaque type LabelDropdownJS_labels$fragmentType: LabelDropdownJS_labels$ref;
export type LabelDropdownJS_labels = $ReadOnlyArray<{|
  +color: ?string,
  +name: ?string,
  +id: string,
  +category: ?{|
    +id: string,
    +name: ?string,
  |},
  +$refType: LabelDropdownJS_labels$ref,
|}>;
export type LabelDropdownJS_labels$data = LabelDropdownJS_labels;
export type LabelDropdownJS_labels$key = $ReadOnlyArray<{
  +$data?: LabelDropdownJS_labels$data,
  +$fragmentRefs: LabelDropdownJS_labels$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "LabelDropdownJS_labels",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Label"
};
})();
// prettier-ignore
(node/*: any*/).hash = '0edf1d963115d6c46df6b56864fcb549';

module.exports = node;
